<template>
    <div>
      <ion-grid class="page-center-logo">
        <ion-row>
          <ion-col>
            <img src="/assets/images/carter/carterLogo.jpeg" alt />
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </template>
  
  <script>
  import { AuthenticationService } from "../service/account/authenticator.service";
  import { LocalStorage } from "../data/localstorage";
  
  export default {
    name: "CarterAppLaunch",
    computed: {
      loggedIn: function() {
        return this.$store.state.user.isAuthenticated;
      },
      userRole: function() {
        return this.$store.state.user.userRole;
      }
    },
    data() {
      return {
        landpage: this.userRole ? this.userRole : "LOGIN"
      };
    },
    created() {
      
    },
    mounted() {
      setTimeout(() => {
        const user = new LocalStorage().user;
        if (user) {
          
          if (this.$route.name == "CarterAppLaunch") {
            this.userLandingPage(user);
          }
        } else {
          window.localStorage.clear();
          this.$router.push("/login");
        }
      }, 5000);
    },
    methods: {
      async userLandingPage(user) {
        try {
          if(user.id == 12345) {
            this.$router.push("/carter/carterHome");
          } else {
            const userPermissions = await new AuthenticationService().permissionsOfUser(
            user
          );
          
          const isCustomer = userPermissions.find(
            userPermission => userPermission.id == "10|C"
          );
          const isAdmin = userPermissions.find(
            userPermission => userPermission.id == "10|T"
          );
          const isCorpUser = userPermissions.find(
            userPermission => userPermission.id == "130|C"
          )
          if (isCustomer) {
            this.$router.push("/customer/reservation");
          } else if (isAdmin) {
            this.$router.push("/admin/adminDashboard");
          } else if(isCorpUser) {
            this.$router.push("/corporate/dashboard");
          } 
          else {
            this.$router.push("/common/helpdesk");
          }
          }
          
        } catch (error) {
          window.localStorage.clear();
          this.$router.push("/login");
        }
      }
    }
  };
  </script>
  
  <style scoped>
    .page-center-logo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  @media screen and (min-width: 720px) {
    .page-center-logo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  </style>
  